module.exports = __webpack_public_path__ + "static/img/shangbiaozhuce.8a67d2f9.jpg";